<template>
    <div :id="`question-module-${attach.id}`">
        <div
            :key="`attach-text-${attach.id}`"
            class="html padded question"
            v-html="renderText(attach.title)"
        />
        <template v-if="attach.data.questionType === 'slider'">
            <div
                :key="`attach-${attach.id}-bar`"
                class="html padded swiper-no-swiping"
            >
                <div
                    class=""
                    style="margin: 30px 0px 15px; position: relative"
                >
                    <f7-range
                        :min="parseFloat(attach.data.min)"
                        :max="parseFloat(attach.data.max)"
                        :step="1"
                        :value="attach.slideId"
                        @range:change="onSliderChange(attach, $event)"
                        @range:changed="onSliderChanged(attach, $event)"
                    />
                    <div class="currentDisplay">{{ attach.slideId }}</div>
                </div>
                <p style="font-size: 13px; color: #ccc">{{ attach.data.minUnit }}<span style="float: right">{{ attach.data.maxUnit }}</span></p>
            </div>
        </template>
        <template v-else-if="attach.data.questionType === 'opentext'">
            <div :key="`attach-${attach.id}-bar`">
                <f7-list
                    inline-labels
                    no-hairlines-md
                >
                    <f7-list-item style="position: relative">
                        <f7-input
                            :value="attach.myAnswer ? attach.myAnswer.choiceText : ''"
                            :placeholder="attach.id === 1848 ? 'This week...' : 'Type your answer here'"
                            type="textarea"
                            resizable
                            style="border-bottom: 1px solid transparent; width: 100%; color: black;"
                            input-style="min-height: 122px"
                            @input="changeText"
                        />
                        <span
                            v-if="attach.id === 1848"
                            slot="after"
                            style="position: absolute; top: 10px; right: 10px"
                        ><i class="ion ion-ios-book" /> Private</span>
                    </f7-list-item>
                </f7-list>
                <f7-block>
                    <div class="ansButtons ">
                        <f7-button
                            color="red"
                            fill
                            round
                            @click="sendAnswerText(attach)"
                        >SUBMIT</f7-button>
                    </div>
                </f7-block>
            </div>
        </template>
        <div
            v-else
            :key="`attach-${attach.id}`"
            class="ansButtons "
        >
            <template v-for="(answer, index) in attach.data.answers">
                <f7-button
                    v-if="answer.title"
                    :class="`${(attach.myAnswer && unit.type !== 'game' && attach.data.answers[attach.myAnswer.choiceInt] && attach.myAnswer.choiceInt === index) ? (!isPulse || lastAnswer ? 'myAnswer' : '') : ' '}`"
                    :key="`button-${attach.id}-${index}`"
                    color="red"
                    fill
                    round
                    href="#"
                    @click="answerDo(attach, answer, index)"
                >
                    <span v-if="isPulse">
                        <i
                            v-if="index === 0"
                            class="weather ion-ios-sunny-outline"
                        />
                        <i
                            v-else-if="index === 1"
                            class="weather ion-ios-partlysunny-outline"
                        />
                        <i
                            v-else-if="index === 2"
                            class="weather ion-ios-cloudy-outline"
                        />
                        <i
                            v-else-if="index === 3"
                            class="weather ion-ios-rainy-outline"
                        />
                        <i
                            v-else-if="index === 7"
                            class="weather ion-ios-thunderstorm-outline"
                        />
                        <i
                            v-else-if="index === 4"
                            class="weather ion-ios-snowy"
                        />
                    </span>{{ answer.title }}
                    <span>
                        {{ answer.subtitle || '' }}
                    </span>
                </f7-button>
            </template>
        </div>
    </div>
</template>

<script>

import utils from '../../js/utils';
import {
    BEGIN_THE_REVOLUTION,
    CHANGE_YOUR_LIFE_IDS,
    DESIRE_TYPE
} from '../../js/constants';

export default {
    props: ['attach', 'slide', 'unit', 'index'],
    store: [
        'api',
        'user',
        'myTraits',
        'myValueTraits',
        'onboardingCompleted',
        'trackerData',
        'coursesIndex',
        'threeWords'
    ],
    data () {
        return {
            answer: 'You need to answer!',
            lastAnswer: '',
            question: {
                id: 0,
                data: {
                    answers: []
                }
            },
        };
    },
    computed: {
        isPulse: function () {
            return this.attach.id === 1845;
        }
    },
    watch: {},
    mounted: function () {
    },
    methods: {
        renderText: function (text) {
            // remove already set targets
            text = text.replace(/(<a [^>]*)(target="[^"]*")([^>]*>)/gi, '$1$3');
            // remove already set classes
            text = text.replace(/(<a [^>]*)(class="[^"]*")([^>]*>)/gi, '$1$3');
            // add new target="_blank"
            let destination = pgap ? '_system' : '_blank';
            return text.replace(/(<a [^>]*)(>)/gi, '$1 target="' + destination + '" class="external" $2');
        },
        answerDo: function (attach, answer, index) {
            if (pgap && window.Vibrate) window.Vibrate.vibrate('light');
            if (this.isPulse) {
                this.lastAnswer = answer.title;
            }
            this.$events.fire('trackEvent', `button_press`, 'button_press', attach.id, answer.title, {
                question: attach.title.replace(/(<([^>]+)>)/ig, ""),
                questionId: attach.id,
                answerIndex: index,
                answer: answer.title
            })
            if (answer.actions && answer.actions.length) {
                for (let i = 0; i < answer.actions.length; i++) {
                    const action = answer.actions[i];

                    utils.actionLog({
                        location: 'Question',
                        method: 'answerDo',
                        info: 'answer action: ',
                        dataValue: action.name
                    });

                    switch (action.name) {
                    case 'link':
                        window.open(action.target, '_system');
                        break;

                    case 'internalLink':
                        if (action.value === 'main') {
                            this.$f7router.view.router.navigate(action.target);
                            f7.popup.get('#popup').open();
                            f7.popup.get('#popup').close();
                            f7.popup.get('#popup2').close();
                            f7.popup.get('#popup3').close();
                        } else {
                            let view = 'popup2';
                            if (this.$f7router.view.name !== 'popup') view = 'popup3';
                            f7.views[view].router.navigate(action.target, {
                                animate: false,
                                clearPreviousHistory: true,
                            });
                            setTimeout(() => {
                                // f7.popup.get(`#${view}`).close();
                                if (f7.popup.get(`#${view}`)) {
                                    f7.popup.get(`#${view}`).open();
                                }
                            }, 200);
                        }
                        break;

                    case 'goToSlide':
                        this.$f7router.view.router.navigate(`/units/${this.unit.id}?page=${action.target}`);
                        if (!pgap && location.hostname !== 'localhost') {
                            window.history.pushState(null, "", `/web/units/${this.unit.id}?page=${action.target}`);
                        }
                        break;

                    case 'goToUnit':
                        // eslint-disable-next-line no-case-declarations
                        let view = 'popup2';
                        if (this.$f7router.view.name !== 'popup') view = 'popup3';
                        f7.views[view].router.navigate(`/units/${action.target}`, {
                            animate: false,
                            clearPreviousHistory: true,
                        });
                        console.log('load in view', view, `/units/${action.target}`)
                        setTimeout(() => {
                            // f7.popup.get(`#${view}`).close();
                            f7.popup.get(`#${view}`).open();
                        }, 200);
                        if (!pgap && location.hostname !== 'localhost') {
                            window.history.pushState(null, "", `/web/units/${action.target}`);
                        }
                        break;

                    case 'goToCourse':
                        f7.popup.get('#popup').open();
                        f7.popup.get('#popup').close();
                        f7.popup.get('#popup2').close();
                        f7.popup.get('#popup3').close();
                        if (!pgap) window.history.pushState(null, "", '/web' + f7.views['main'].router.currentRoute.path);
                        setTimeout(() => {
                            f7.views['main'].router.navigate(`/courses/${action.target}`);
                        }, 100);
                        break;

                    case 'setTrait':
                        this.setTrait(action.target);
                        break;

                    case 'setValueTrait':
                        this.setTrait(action.target, action, attach);
                        break;

                    case 'event':
                        this.$events.fire('trackEvent', `button_event_${action.target}`, 'custom button event', this.unit.id, this.unit.name)
                        break;

                    case 'close':
                        f7.popup.get(`#${this.$f7router.view.name}`).open();
                        f7.popup.get(`#${this.$f7router.view.name}`).close();
                        break;

                    case 'complete':
                        this.complete(true);
                        break;

                    case 'next':
                        if (this.isLastAttachment(attach.id)) {
                            this.nextSlide(true);
                        }
                        break;

                    default:
                        utils.actionLog({
                            location: 'Question',
                            method: 'answerDo',
                            info: 'Unknown action: ',
                            dataValue: action.name
                        });
                    }
                }
            }
            // This happens after as setTrait sometimes need prev Ans
            setTimeout(() => {
                this.sendAnswer(attach, index);
            }, 0);
        },
        changeText: function (e) {
            this.submissionText = e.target.value;
        },
        nextSlide: function (delayed) {
            if (this.index + 1 >= this.unit.slides.length) return;
            this.$events.fire('user-progress', {
                itemId: this.unit.isVersionOf || this.unit.id,
                courseId: this.unit.courseId,
                topicId: this.coursesIndex[this.unit.courseId] ? this.coursesIndex[this.unit.courseId].topicId : 0,
                type: 'unit',
                progress: parseInt(((this.index + 1) / this.unit.slides.length) * 100, 10),
                item: this.unit,
                complete: false
            });
            setTimeout(
                () => {
                    this.$f7router.view.router.navigate(`/units/${this.unit.id}?page=${this.index + 1}`);
                },
                delayed ? 200 : 0
            );
        },
        complete: function (complete, skip) {
            console.log('*********************************** QUESTION');
            console.log('[Progress] complete unit', this.unit.id, complete, skip);

            if (this.unit.id === BEGIN_THE_REVOLUTION && !this.onboardingCompleted) {
                window.localStore.setItem('onboardingCompleted', 1);
                this.onboardingCompleted = 1;
                this.$events.fire(`unit-completed-${this.unit.id}`);
            }
            else if (CHANGE_YOUR_LIFE_IDS.includes(this.unit.id) && this.onboardingCompleted < 2) {
                window.localStore.setItem('onboardingCompleted', 2);
                this.onboardingCompleted = 2;
                this.$events.fire(`unit-completed-${this.unit.id}`);
            } else if (this.unit.id === DESIRE_TYPE && this.onboardingCompleted < 2) {
                window.localStore.setItem('onboardingCompleted', 2);
                this.onboardingCompleted = 2;
                this.$events.fire(`unit-completed-${this.unit.id}`);
            }
            this.$events.fire(`unit-next-${this.unit.id}`, complete, skip);
        },
        sendAnswerText: function (attach) {
            if (!this.user.id) return;
            if (attach.id === 1848) {
                // is pulse
                this.$http
                    .post(`${this.api}/results/pulseAddText`, {
                        questionId: attach.id,
                        // slideId: this.slide.id, this is unit count
                        choiceText: `${this.threeWords.join(', ')}====${this.submissionText}`,
                        tracker: this.unit.type === 'tracker' ? true : false,
                        day: this.user.day
                    })
                    .then(
                        () => {
                            localStore.setItem('trackerTakenOnce', true);
                            this.$events.fire('pulse-get');
                            this.$events.fire('pulse_completed');
                            this.$events.fire(
                                'trackEvent',
                                `pulse_completed`,
                                'progress',
                                this.unit.id,
                                this.unit.name,
                                {
                                    mood: this.lastAnswer,
                                    words: this.threeWords,
                                    hasText: this.submissionText && this.submissionText.length > 1 ? true : false
                                }
                            );
                        },
                        () => { }
                    );
                this.$events.fire('notifications-push', {
                    type: 'pulse',
                    cb: () => { },
                });
                if (!localStore.getItem('trackerTakenOnce')) {
                    f7.views['main'].router.navigate('/home', { reload: false, animatePages: false });
                }
                return setTimeout(() => {
                    f7.popup.get('#popup').open();
                    f7.popup.get('#popup').close();
                    f7.popup.get('#popup2').close();
                    f7.popup.get('#popup3').close();
                }, 500);
            }
            attach.myAnswer = {
                questionId: attach.id,
                slideId: this.slide.id,
                choiceText: this.submissionText
            };
            this.$events.fire(`answer:${attach.id}`, attach.myAnswer);
            this.$http
                .post(`${this.api}/results`, {
                    questionId: attach.id,
                    slideId: this.slide.id,
                    choiceText: this.submissionText,
                    tracker: this.unit.type === 'tracker' ? true : false,
                    day: this.user.day
                })
                .then(() => { }, (response) => {
                    utils.failedRequest('popup', response);
                });
            if (this.isLastAttachment(attach.id)) {
                this.nextSlide(true);
            }
        },
        isLastAttachment: function (attachId) {
            console.log("here is the issue-==== attachid", attachId)
            if (attachId === this.slide.attachments[this.slide.attachments.length - 1].id) {
                return true;
            }
            return false;
        },
        sendAnswer: function (attach, choiceInt) {
            if (!this.user.id) return console.log('Must be logged to answer.');
            attach.myAnswer = {
                questionId: attach.id,
                slideId: this.slide.id,
                choiceInt
            };
            // double check responsiveness
            for (let i = 0; i < this.slide.attachments.length; i++) {
                if (attach.id === this.slide.attachments[i].id) {
                    this.$set(this.slide.attachments[i], 'myAnswer', attach.myAnswer);
                }
            }
            // fill in answers everywhere
            for (let i = 0; i < this.unit.slides.length; i++) {
                const slide = this.unit.slides[i];
                for (let j = 0; j < slide.attachments.length; j++) {
                    const a = slide.attachments[j];
                    if (a.type === 'answer') {
                        if (a.data.questionId === attach.id) {
                            this.$set(a, 'myAnswer', {
                                questionId: attach.id,
                                slideId: this.slide.id,
                                choiceInt
                            });
                        }
                    }
                }
            }
            this.$events.fire(`answer:${attach.id}`, attach.myAnswer);
            this.$http
                .post(`${this.api}/results`, {
                    questionId: attach.id,
                    slideId: this.unit.type === 'tracker' ? this.trackerData.countSinceLast : this.slide.id,
                    choiceInt,
                    tracker: this.unit.type === 'tracker' ? true : false,
                    day: this.user.day
                })
                .then(() => { }, (response) => {
                    utils.failedRequest('popup', response);
                });
        },
        correctAnswer: function () {
            if (!this.slide.data.answers) return;
            if (!this.slide.data.questionId && parseFloat(this.index) === 0) return;
            if (!this.slide.data.questionId && !this.slides[parseFloat(this.index) - 1]) return;
            if (this.slide.data.questionId) {
                this.$http.get(`${this.api}/slides/${this.slide.data.questionId}`).then(
                    response => {
                        this.question = response.body;
                        if (
                            response.body.myAnswer &&
                            this.slide.data.answers &&
                            this.slide.data.answers[response.body.myAnswer.choiceInt]
                        ) {
                            this.answer = this.slide.data.answers[response.body.myAnswer.choiceInt].title;
                        }
                    },
                    () => {
                        // console.log('Invalid slide id!');
                    }
                );
            } else {
                this.question = this.slides[parseFloat(this.index) - 1];
                if (!this.question.id) return;
                const myAnswer = this.question.myAnswer;
                if (!myAnswer) return (this.answer = 'You need to answer the previous slide!');
                if (this.slide.data.answers && this.slide.data.answers[myAnswer.choiceInt])
                    this.answer = this.slide.data.answers[myAnswer.choiceInt].title;
            }
        },
        onSliderChange: function (attach, value) {
            attach.slideId = value;
        },
        onSliderChanged: function (attach, value) {
            if (attach.data.action === 'setValueTrait') {
                this.setTrait(
                    attach.data.target,
                    {
                        setType: attach.data.setType,
                        value
                    },
                    attach
                );
            }
            // This happens after as setTrait sometimes need prev Ans
            setTimeout(() => {
                this.sendAnswer(attach, value);
            }, 0);
        },
        setTrait: function (traitId, answer, attach) {
            let send = {
                traitId,
                tracker: this.unit.type === 'tracker' ? true : false,
            };
            // console.log('settrait', traitId, answer, attach);
            if (answer) {
                // slide or multi
                send.setType = answer.setType || 'equals';
                send.value = parseFloat(answer.value);
                if (attach.myAnswer && attach.data.answers) {
                    console.log(attach.data.answers, attach.myAnswer.choiceInt)
                    let ans = attach.data.answers[attach.myAnswer.choiceInt];
                    if (typeof ans !== 'undefined' && ans.actions) {
                        for (let i = 0; i < ans.actions.length; i++) {
                            if (ans.actions[i].name === "setValueTrait") {
                                send.previousValue = parseFloat(ans.actions[i].value);
                            }
                        }

                    }
                } else if (attach.myAnswer && typeof attach.myAnswer.choiceInt !== 'undefined') {
                    // slider
                    send.previousValue = parseFloat(attach.myAnswer.choiceInt);
                }
            }
            this.$http.post(`${this.api}/users/${this.user.id}/traits`, send).then(
                response => {
                    Vue.set(this, 'myTraits', response.body.traits || []);
                    Vue.set(this, 'myValueTraits', response.body.valueTraits || []);
                    this.$events.fire('userUpdateTraits');
                    if (this.unit.type === 'tracker') {
                        this.$events.fire(`refresh-custom-1`);
                    }
                },
                response => {
                    utils.failedRequest('popup', response)
                }
            );
        },
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.padded {
    padding: 24px 0px 0;
}
.html {
    font-size: 20px;
    line-height: 30px;
    text-align: left;
    margin: 0 auto;
    max-width: 90%;
    text-align: left;
    p {
        margin: 0;
    }
    h3 {
        font-family: Editor-bold;
        // margin-bottom: 0px;
    }
    .ql-align-center {
        text-align: center;
    }
    ul {
        padding-left: 20px;
        text-align: left;
    }
}
</style>
